/**
 * Evaluates account-level feature flags returned by the platform API.
 * Mirrors tracking-2's FeatureFlagUtils so RAM Live uses the same flag semantics.
 */

export function isFeatureEnabled(
  featureFlags: Record<string, boolean> | undefined,
  featureName: string
): boolean {
  if (!featureFlags) {
    return false;
  }
  return featureFlags[featureName] ?? false;
}
